// Wait 100ms before removing the waves effect from DOM elements, in order to make sure they have been initialized.
export const removeWavesEffectFromAllElements = () => (setTimeout(
    () => jQuery('.waves-effect').removeClass('waves-effect waves-light'),
    100
));

export const getCookiesAsObject = () => (
    Object.fromEntries(document.cookie.split(/; */).map(c => {
        const [key, ...v] = c.split('=');
        return [key, decodeURIComponent(v.join('='))];
    }))
);

export const setupConfirmationHandlerForLinks = () => {
    document.addEventListener('click', function (event) {
        const specificURL = 'https://www.herrforsnat.fi/';
        const currentUrl = 'https://www.herrfors.fi';

        if (window.location.href.includes(currentUrl)) {
            if (event.target.tagName === 'A' && event.target.href.includes(specificURL)) {
                window.event.preventDefault();
                if (window.confirm(document.querySelector('#external-link-confirmation-translation').textContent)) {
                    window.open(event.target.href, '_blank');
                }
            }
        }
    })
};
